/**
 * Helper
 */
var helper = require('../../helper');

$(function() {

	/*********************
	 * TYPEAHEAD SECTION *
	 *********************/
	/** Make engine object */
	var engine = new Bloodhound({
		datumTokenizer: function (datum) {
			return Bloodhound.tokenizers.whitespace(datum.name);
		},
		queryTokenizer: Bloodhound.tokenizers.whitespace,
		remote: {
			url: helper.getOrigin() + "/api/clients/ajax/%QUERY",
			wildcard: '%QUERY'
		},
		filter: function (response) {
			return $.map(response.clients, function (object) {
				return {
					id: object.id,
					name: object.name
				};
			});
		}
	});

	$.fn.dataTable.moment( 'DD/MM/YYYY' );

    var $datatable = $('#datatable-all-certificates'),
        columns = [
            {data: 'type', name: 'type', searchable: false},
	        {data: 'client', name: 'clientName'},
	        {data: 'date_completed', name: 'documents.date_completed'},
	        {data: 'date_expiration', name: 'documents.date_expiration'},
	        {data: 'date_contractor_appointment', name: 'documents.date_contractor_appointment'},
	        {data: 'propertyName', name: 'propertyName'},
	        {data: 'actions', name: 'actions', orderable: false, searchable: false, className : "action" }
        ],
	    dataTables_buttons = [
		    {
			    extend: 'csv',
			    text: 'Export as CSV',
			    exportOptions: {
				    columns: [0,1,2,3,4,5]
			    },
		    },
		    {
			    extend: 'pdf',
			    text: 'Export as PDF',
			    exportOptions: {
				    columns: [0,1,2,3,4,5]
			    }
		    },
		    {
			    extend: 'print',
			    text: 'Print table',
			    exportOptions: {
				    columns: [0,1,2,3,4,5]
			    }
		    },
		    {
			    extend: 'colvis',
			    //     columns: ':gt(0)'
		    }
	    ],
        $dt;

	$dt = $datatable.DataTable({
        "dom": "<'dt-toolbar'lfB>tr<'row'<'col-sm-5'i><'col-sm-7'p>>",
	    "buttons": dataTables_buttons,
        "processing": true,
        "serverSide": true,
        "responsive": true,
        "lengthMenu": [[ 30, 10, 25, 50, 75, 100], [ 30, 10, 25, 50, 75, 100]],
	    "ajax": {
		    url: helper.getOrigin() + "/api/clients/certificates",
		    data: function (d) {
			    d.type_id = $('input[name=type_id]:checked').val();
			    d.cert_status = $('input[name=cert_status]:checked').val();
			    d.property_type = $('input[name=property_type]:checked').val();
			    d.client_id = $('input[id=client_id]').val();
		    },
		    method: 'POST',
	    },
        "autoWidth" : false,
        "order": [[ 0, "asc" ]],
        "columns": columns
    });

	$('#search-form').on('submit', function(e) {

		$dt.draw();
		e.preventDefault();
	});

	/** Run TypeAhead */
	$('.typeahead').typeahead(null, {
		minLength: 1,
		display: 'name',
		valueKey: 'id',
		name: 'suggestions',
		displayKey: 'name',
		limit: 15,
		templates: {
			empty: ['<div class="empty-message" style="padding: 10px;"><strong>', 'Unable to find clients', '</strong></div>'].join('\n'),
			suggestion: function (data) {
				return '<p style="font-size: 100%; cursor: pointer;"><strong>' + data.name + '</strong></p>';
			}
		},
		source: engine
	});

	/*************************************
	 * TYPEAHEAD SELECTED PROPERTY EVENT *
	 *************************************/

	$('.js-client-field-typeahead').bind('typeahead:select', function (ev, suggestions) {
		$('input[id=client_id]').val(suggestions.id);
	});

});
